export const getRoles = () => {
  try {
    return JSON.parse(localStorage.getItem("roles")) || [];
  } catch {
    return [];
  }
};

export const isAdmin = () => {
  return getRoles().includes("admin");
};

export const isReadonly = () => {
  return getRoles().includes("readonly");
};